module.exports = __webpack_public_path__ + "img/w_logo.36e52caf.png";